import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import { Box } from 'components/Box'
import { Text } from 'components/Text'
import { interactions } from 'styles'

const Root = styled(Box).attrs({
  as: 'button',
})`
  ${interactions}
  border: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  user-select: none;
  cursor: pointer;
  box-shadow: ${({ backgroundColor, disabled, shadowColor, theme }) =>
    disabled
      ? 'none'
      : `0 1px 1px 0 ${
          backgroundColor === 'white'
            ? theme.colors.white
            : theme.colors.primary
        }, 0 3px 13px 0 ${theme.utils.colors.fade(
          theme.colors[shadowColor || backgroundColor],
          0.32
        )}`};
`

const Label = styled(Text)`
  margin: 0;
  align-items: center;
  text-align: center;
`

export const Button = ({
  color,
  backgroundColor,
  disabled,
  icon: Icon,
  label,
  ...rest
}) => (
  <Root
    {...rest}
    interaction="bump"
    disabled={disabled}
    backgroundColor={disabled ? 'gray' : backgroundColor}
    borderRadius={9}
    minHeight={[7, 7, 8]}
    paddingX={[4, 5, 6]}
  >
    <Label fontSize={[2, 2, 3]} fontWeight="600" lineHeight={3} color={color}>
      {label}
    </Label>
    {Icon ? <Icon color="white" size={16} /> : null}
  </Root>
)

Button.propTypes = {
  backgroundColor: PropTypes.string,
  color: PropTypes.string,
  icon: PropTypes.func,
  label: PropTypes.string,
  shadowColor: PropTypes.string,
}

Button.defaultProps = {
  backgroundColor: 'primary',
  color: 'white',
}
